<template>
  <div style="width: 92%; margin: 0 auto; padding-top: 35px">
    <Header title="任务详情" />
    <div class="btitle">
      工程信息
      <div style="float: right; margin-right: 10px; line-height: 32px">
        <el-tag size="small" style="background: #fff; margin-right: 10px" :type="getStateColor(data.state)">{{
          getStateText(data.state, data.sub_state) }}</el-tag>

        <el-button size="mini" type="primary" @click.stop="showDevice(data.id)" v-if="
          checkRole([3, 5]) &&
          data.state >= 3 &&
          data.state < 6 &&
          data.is_tester == 1
        ">设备</el-button>
        <el-button size="mini" type="primary" @click.stop="testTask(data)"
          v-if="checkRole([3, 5]) && (data.state == 4 || data.state == 5)">检测</el-button>
        <el-button size="mini" type="primary" @click.stop="passPrivateCar(data.id)"
          v-if="checkRole(2) && data.state == 3 && data.sub_state == 1">批准私车</el-button>
        <el-button size="mini" :type="data.state == 3 ? 'primary' : ''" @click.stop="setCarForTask(data.id)" v-if="
          checkRole(4) &&
          ((data.state == 3 && data.sub_state != 1) || data.state == 4)
        ">派车</el-button>
        <el-button size="mini" :type="data.state == 2 ? 'primary' : ''" @click.stop="allocateTask(data.id)"
          v-if="checkRole(3) && (data.state == 2 || data.state == 3)">派人</el-button>
        <el-button size="mini" type="primary" @click.stop="showPass(data.id)"
          v-if="checkRole(2) && data.state == 1">审核</el-button>
        <el-button size="mini" type="primary" @click.stop="showCommonQrcode(data.id)"
          v-if="checkRole(5) && data.state == 6">评价二维码</el-button>
      </div>
    </div>
    <div class="item">
      <label class="lft">任务编号：</label>
      <label class="cnt">{{ data.taskno }}</label>
    </div>
    <div class="item">
      <label class="lft">任务派发单位：</label>
      <label class="cnt">{{ data.test_company }}</label>
    </div>
    <div class="item">
      <label class="lft">工程名称：</label>
      <label class="cnt">{{ data.enginner_name }}</label>
    </div>
    <div class="item">
      <label class="lft">检测项目：</label>
      <label class="cnt">{{ data.test_item }}</label>
    </div>
    <div class="item">
      <label class="lft">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</label>
      <label class="cnt">{{ data.customer }}</label>
    </div>
    <div class="item">
      <label class="lft">联系电话：</label>
      <label class="cnt">{{ data.customer_mobile }}</label>
    </div>
    <div class="item">
      <label class="lft">要求出报告公司：</label>
      <label class="cnt">{{ data.report_company }}</label>
    </div>

    <div class="item">
      <label class="lft">级别：</label>
      <label class="cnt">{{ data.jibie }}</label>
    </div>
    <div class="item">
      <label class="lft">是否签订合同：</label>
      <label class="cnt">{{
        data.is_qiandinghetong == "true" ? "是" : "否"
      }}</label>
    </div>
    <div class="item">
      <label class="lft">合同编号：</label>
      <label class="cnt">{{ data.hetongbianhao }}</label>
    </div>
    <div class="item">
      <label class="lft">内容及要求：</label>
      <label class="cnt">{{ data.neirongyaoqiu }}</label>
    </div>
    <div class="item">
      <label class="lft">是否需要现场收费：</label>
      <label class="cnt">{{ data.is_shoufei == "true" ? "是" : "否" }}</label>
    </div>
    <div class="item">
      <label class="lft">费用情况：</label>
      <label class="cnt">{{ data.expenses }}</label>
    </div>
    <div class="item">
      <label class="lft">付款方式：</label>
      <label class="cnt">{{ data.paytype }}</label>
    </div>

    <div class="item">
      <label class="lft">需出具报告日期：</label>
      <label class="cnt">{{ data.report_date }}</label>
    </div>
    <div class="item">
      <label class="lft">要求进场时间：</label>
      <label class="cnt">{{ data.require_in_date }}</label>
    </div>
    <div class="item">
      <label class="lft">所在地区：</label>
      <label class="cnt">{{ data.province }} {{ data.city }} {{ data.area }}</label>
    </div>
    <div class="item">
      <label class="lft">详细地址：</label>
      <label class="cnt">{{ data.address }}</label>
    </div>

    <div class="item">
      <label class="lft">业务经理：</label>
      <label class="cnt">{{ data.business_name }}</label>
    </div>

    <div class="item">
      <label class="lft">携带设备：</label>
      <label class="cnt">
        <el-tag style="margin-right: 10px; margin-bottom: 5px" v-for="item in data.deivcelist">{{ item.name }}({{
          item.no }})</el-tag>
      </label>
    </div>
    <div class="item">
      <label class="lft">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
      <label class="cnt">{{ data.remark }}</label>
    </div>

    <div class="item">
      <label class="lft">任务附件：</label>
      <label class="cnt">
        <div class="filelist">
          <div class="fileitem" v-for="(file, index) in data.fileList">
            <a :href="file.url">{{ index + 1 }}、{{ file.name }}</a>
          </div>
        </div>
      </label>
    </div>
    <div class="btitle">外派记录</div>
    <div class="item">
      <table class="tb">
        <tr>
          <th>日期</th>
          <th>组长</th>
          <th>组员</th>
          <th>车辆</th>
          <th>司机</th>
        </tr>
        <tr v-for="item in data.sublist">
          <td>{{ item.gotime }}</td>
          <td>{{ item.groupleader }}</td>
          <td>
            {{ item.groupusers.join("、") }}
          </td>
          <td>{{ item.carno }}</td>
          <td>{{ item.driver }}</td>
        </tr>
      </table>
    </div>

    <div class="btitle">检测信息</div>
    <div class="item">
      <label class="lft">签到时间：</label>
      <label class="cnt">{{ data.sign_time }}</label>
    </div>
    <div class="item">
      <label class="lft">现场照片：</label>
      <div class="cnt" style="text-align: right">
        <el-image style="width: 50px; height: 100px" :src="data.img_1" v-if="data.img_1"
          :preview-src-list="srcList"></el-image>
        <el-image style="width: 50px; height: 100px; margin-left: 15px" :src="data.img_2" v-if="data.img_2"
          :preview-src-list="srcList"></el-image>
        <el-image style="width: 50px; height: 100px; margin-left: 15px" :src="data.img_3" v-if="data.img_3"
          :preview-src-list="srcList">
        </el-image>
      </div>
    </div>
    <div class="item">
      <label class="lft">完成时间：</label>
      <label class="cnt">{{ data.compelete_time }}</label>
    </div>

    <!-- <div class="btitle">客户评价</div>
    <div class="item">
      <label class="lft">评价得分：</label>
      <label class="cnt"
        ><el-rate
          disabled
          v-model="data.comment_stars"
          text-color="#ff9900"
          :score-template="data.comment_stars"
        >
        </el-rate
      ></label>
    </div>
    <div class="item">
      <label class="lft">评价内容：</label>
      <label class="cnt">{{ data.comment_word }}</label>
    </div>
    <div class="item">
      <label class="lft">联系电话：</label>
      <label class="cnt">{{ data.comment_mobile }}</label>
    </div> -->

    <div class="functionInfo" style="margin-top: 20px; padding-bottom: 0px">
      <el-button type="info" style="width: 48%" v-if="dkState == 1">已打卡</el-button>
      <el-button type="primary" style="width: 48%" v-else @click="getLocation()">打卡</el-button>
      <el-button type="info" plain style="width: 48%" v-if="sBState == 1">设备已进场</el-button>
      <el-button type="primary" plain style="width: 48%" v-else @click="scanCode()">设备进场</el-button>
    </div>
    <div style="margin-top: 20px; padding-bottom: 50px">
      <el-button plain style="width: 100%" @click="backlist()">返回</el-button>
    </div>

    <el-dialog title="审核任务" :visible.sync="dialog.taskPass" width="90%">
      <TaskPass ref="taskPass" @onPassed="
        dialog.taskPass = false;
      reSearch();
      "></TaskPass>
    </el-dialog>
    <el-dialog title="分配人员" :visible.sync="dialog.taskAllocate" width="90%">
      <TaskAllocate ref="taskAllocate" @onSuccess="
        dialog.taskAllocate = false;
      reSearch();
      "></TaskAllocate>
    </el-dialog>
    <el-dialog title="分配车辆" :visible.sync="dialog.taskSetCar" width="90%">
      <TaskSetCar ref="taskSetCar" @onSuccess="
        dialog.taskSetCar = false;
      reSearch();
      "></TaskSetCar>
    </el-dialog>
    <el-dialog title="携带设备" :visible.sync="dialog.taskSetDevice" :close-on-click-modal="false" width="90%">
      <TaskSetDevice ref="taskSetDevice" @onSuccess="dialog.taskSetDevice = false"></TaskSetDevice>
    </el-dialog>
    <el-dialog title="评价二维码" :visible.sync="dialog.commentQrcode" :close-on-click-modal="false" width="90%">
      <TaskCommentQrcode ref="taskCommentQrcode" @onSuccess="dialog.taskSetDevice = false"></TaskCommentQrcode>
    </el-dialog>

    <el-dialog title="设备信息" :visible.sync="SbInfoState" width="90%" :before-close="handleClose">
      <div class="dialogSbInfo">
        <div class="dialogSbInfoList">设备名称：{{ Sbdata.name }}</div>
        <div class="dialogSbInfoList">设备规格：{{ Sbdata.type }}</div>
        <!-- <div class="dialogSbInfoList">在库状态：{{Sbdata.name}}</div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SbInfoState = false">取 消</el-button>
        <el-button type="primary" @click="getSbAddress">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="位置信息" :visible.sync="weizhiInfoShow" width="90%" :before-close="handleClose">
      <div class="dialogSbInfo">
        <div class="dialogSbInfoList">
          您当前位置为：{{ address }}，是否打卡
        </div>
        <!-- <div class="dialogSbInfoList">在库状态：{{Sbdata.name}}</div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="weizhiInfoShow = false">取 消</el-button>
        <el-button type="primary" v-if="typeState == 1" @click="uptZb">确 定</el-button>
        <el-button type="primary" v-if="typeState == 2" @click="uptdeviceZb">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import TaskPass from "@/views/dialog/task_pass.vue";
import TaskAllocate from "@/views/dialog/task_allocate.vue";
import TaskSetCar from "@/views/dialog/task_setcar.vue";
import TaskSetDevice from "@/views/dialog/task_setdevice.vue";
import TaskCommentQrcode from "@/views/dialog/task_commentqrcode.vue";
import axios from "axios";
export default {
  name: "task_add",
  components: {
    Header,
    TaskPass,
    TaskAllocate,
    TaskSetCar,
    TaskSetDevice,
    TaskCommentQrcode,
  },
  data() {
    return {
      regState:0,
      lguser: { name: "", role: -1 },
      data: {},
      dkState: 0, //人员是否打卡 0未打 1已打
      sBState: 0, //设备是否进场 0未打 1已打
      typeState: 1, //1人员  2设备
      weizhiInfoShow: false, //打卡位置
      sBiD: 0, //设备ID
      Sbdata: {}, //设备信息
      srcList: [],
      latitude: "",
      longitude: "",
      address: "",
      SbInfoState: false, //设备信息弹窗
      statelist: [
        { id: 0, text: "待提交" },
        { id: 1, text: "待审核" },
        { id: 2, text: "待分配" },
        { id: 3, text: "待派车" },
        { id: 4, text: "待检测" },
        { id: 5, text: "检测中" },
        { id: 6, text: "已完成" },
        { id: 7, text: "已评价" },
      ],
      dialog: {
        taskPass: false,
        taskAllocate: false,
        taskSetCar: false,
        taskSetDevice: false,
        commentQrcode: false,
      },
    };
  },
  mounted() {
    var id = this.$route.query.id;
    this.showInfo(id);
    this.regWxInfo();
    this.lguser = JSON.parse(localStorage.getItem("uinfo"));
  },
  methods: {


    handleClose() {

    },
    async regWxInfo() {
      var data = await this.$api.request.get("/device/getwxinfo", {
        params: {
          url: location.href,
        },
      });
      wx.config({
        beta: true,
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["checkJsApi", "scanQRCode", "getLocation"],
      });
      var that = this;
      wx.ready(function () {
        that.regState = 1;
      });
      wx.error(function (res) {
        console.log(res, "55");
        // alert("参数注册失败");
      });
    },


    //获取当前位置并打卡
    getLocation() {
      let that = this;
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        altitude: true,
        success: function (res) {
          var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          var speed = res.speed; // 速度，以米/每秒计
          var accuracy = res.accuracy; // 位置精度
          // alert(latitude,longitude)
          that.latitude = latitude;
          that.longitude = longitude;
          that.typeState = 1;
          that.getAddressInfo(latitude, longitude);
          // that.uptZb(latitude, longitude);
        },
      });
    },
    async getAddressInfo(latitude, longitude) {

      const datainfo = await this.$api.request.get("/staff/get_address", {
        params: {
          latitude,
          longitude,
        },
      });
      let datainfoA = JSON.parse(datainfo)
      console.log(datainfoA);
      // 处理响应数据
      const address =
        datainfoA.result.address +
        datainfoA.result.formatted_addresses.recommend;
      console.log(address);
      this.address = address;
      this.weizhiInfoShow = true;

      // 构建请求URL
      // const url = `http://apis.map.qq.com/ws/geocoder/v1/?location=38.098988,114.50126&key=3S3BZ-MGEKA-7XGK2-CN5QY-5N6W5-W5BNG&output=json`;
    },
    uptZb() {
      let that = this;
      let lat = that.latitude;
      let lng = that.longitude;
      var datainfo = this.$api.request.post("/staff/uptZb", {
        lat,
        lng,
        taskid: that.data.id,
      });

      this.dkState = 1;
      this.weizhiInfoShow = false;
      this.$api.success("打卡成功");
    },

    //扫码查询设备信息
    scanCode() {
      var that = this;
      wx.scanQRCode({
        desc: "scanQRCode desc",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
        success: function (res) {
          // 回调
          var result = res.resultStr; //当needResult为1时返回处理结果

          const urlObject = new URL(result);
          const params = new URLSearchParams(urlObject.search);
          const noValue = params.get("no");
          that.getSbInfo(noValue);
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },

    //获取二维码连接里的参数

    //查询设备信息
    async getSbInfo(no) {
      this.Sbdata = await this.$api.request.get("/device/getByno", {
        params: {
          no,
        },
      });

      this.SbInfoState = true;
      this.sBiD = this.Sbdata.id;
    },

    //设备打卡
    getSbAddress() {
      let that = this;

      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        altitude: true,
        success: function (res) {
          var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          var speed = res.speed; // 速度，以米/每秒计
          var accuracy = res.accuracy; // 位置精度

          that.latitude = latitude;
          that.longitude = longitude;
          // console.log(latitude, longitude);
          that.typeState = 2;
          that.getAddressInfo(latitude, longitude);
        },
      });
    },
    uptdeviceZb() {
      let that = this;
      let lat = that.latitude;
      let lng = that.longitude;
      var data = this.$api.request.post("/staff/uptdeviceZb", {
        id: this.sBiD,
        lat,
        lng,
        taskid: this.data.id,
      });

      this.sBState = 1;
      this.SbInfoState = false;
      this.$api.success("设备进场成功");
    },

    //查询详情
    async showInfo(id) {
      this.data = await this.$api.request.get("/task/get", {
        params: {
          id: id,
        },
      });
      this.dkState = this.data.userisdaka;

      this.sBState = this.data.sbisdaka;

      if (this.data.img_1) {
        this.srcList.push(this.data.img_1);
      }
      if (this.data.img_2) {
        this.srcList.push(this.data.img_2);
      }
      if (this.data.img_3) {
        this.srcList.push(this.data.img_3);
      }
    },
    async backlist() {
      this.$router.replace("/");
    },
    //检查是否有权限
    checkRole(role1, role2) {
      if (role2 != undefined) {
        //检查一个范围
        if (this.lguser.roles) {
          for (var i = role1; i <= role2; i++) {
            if (this.lguser.roles.indexOf(i) < 0) {
              return false;
            }
          }
        } else {
          return this.lguser.role >= role1 && this.lguser.role <= role2;
        }
      } else {
        if (role1 instanceof Array) {
          for (var i = 0; i < role1.length; i++) {
            if (this.lguser.roles) {
              return this.lguser.roles.indexOf(role1[i]) >= 0;
            } else {
              if (this.lguser.role == role1[i]) {
                return true;
              }
            }
          }
          return false;
        } else {
          if (this.lguser.roles) {
            return this.lguser.roles.indexOf(role1) >= 0;
          } else {
            return this.lguser.role == role1;
          }
        }
      }
    },
    getStateText(state, substate) {
      for (var i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].id == state) {
          if (state == 3) {
            if (substate == 1) {
              return "私车审批中";
            } else {
              return "待派车";
            }
          } else {
            return this.statelist[i].text;
          }
        }
      }
    },
    getStateColor(state) {
      switch (state) {
        case 1:
          return "danger";
        case 2:
          return "danger";
        case 3:
          return "danger";
        case 4:
          return "";
        case 5:
          return "";
        case 6:
          return "success";
        case 7:
          return "success";
      }
      return "";
    },
    async passPrivateCar(id) {
      await this.$api.confirm("确认审批通过吗？");
      var data = await this.$api.request.post("/task/pass_privatecar", {
        taskid: id,
      });
      this.$api.success("批准成功");
      var id = this.$route.query.id;
      this.showInfo(id);
    },
    showDevice(id) {
      this.dialog.taskSetDevice = true;
      this.$nextTick(() => {
        this.$refs.taskSetDevice.showInfo(id);
      });
    },
    testTask(item) {
      this.$router.push("/task_make?id=" + item.id);
    },
    showPass(id) {
      this.dialog.taskPass = true;
      this.$nextTick(() => {
        this.$refs.taskPass.showInfo(id);
      });
    },
    allocateTask(id) {
      this.dialog.taskAllocate = true;
      this.$nextTick(() => {
        this.$refs.taskAllocate.showInfo(id);
      });
    },
    setCarForTask(id) {
      this.dialog.taskSetCar = true;
      this.$nextTick(() => {
        this.$refs.taskSetCar.showInfo(id);
      });
    },
    showCommonQrcode(id) {
      this.dialog.commentQrcode = true;
      this.$nextTick(() => {
        this.$refs.taskCommentQrcode.showInfo(id);
      });
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
  justify-content: space-between;

  border-bottom: 1px solid #eee;
  padding-top: 3px;
  padding-bottom: 3px;
}

.item .lft {
  text-align: left;
  min-width: 80px;
}

.item .cnt {
  text-align: left;
}

.btitle {
  font-size: 17px;
  background: #eee;
  text-align: left;
  line-height: 35px;
  padding-left: 5px;
  margin-top: 20px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  border-left: 1px solid #fff;
  border-top: 1px solid #fff;
}

.tb th,
.tb td {
  font-weight: normal;
  background: #e0f4ff;
  font-size: 13px;
  line-height: 30px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
}

.tb td {
  line-height: 25px;
}

.filelist {}

.fileitem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: initial;
}

.fileitem a {
  color: #2c3e50;
  text-decoration: none;
  text-align: left;
}

.dialogSbInfo {
  text-align: left;

  .dialogSbInfoList {
    margin-bottom: 10px;
  }
}
</style>
